import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import HomepageAnimation from "./homePageAnimation";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShareIcon from "@mui/icons-material/Share";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { useCart } from "../../../hooks/shareContext";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  TransformWrapper,
  TransformComponent,
  ReactZoomPanPinchRef,
} from "react-zoom-pan-pinch";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const BASE_SHORT_URL = import.meta.env.VITE_BASE_SHORT_URL;
const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;

import { axiosInstance } from "../../../utils/tokenSetCookie";
import { toast } from "react-toastify";
import PdfViewerModal from "../../pdf_view/pdfviewermodal";
import { useLanguageContext } from "../../../components/language/languageContext";
import { AxiosError } from "axios";
import {
  favoriteAnim,
  ControlsProps,
  SystemData,
  posterData,
} from "../../../types/types";
import HomeNav from "./homeNav";
//for loader
import CircularProgress from "@mui/material/CircularProgress";
import LoginRestriction from "../../../utils/loginRestriction";

const Controls: React.FC<ControlsProps> = ({
  zoomIn,
  zoomOut,
  resetTransform,
}) => (
  <Box
    sx={{
      textAlign: "end",
      position: "absolute",
      top: "10px",
      left: "0",
      right: "0",
      zIndex: "9",
    }}
  >
    <ZoomInIcon
      fontSize="medium"
      onClick={() => zoomIn()}
      sx={{ cursor: "pointer", color: "#fff", marginRight: "0.5%" }}
    />
    <ZoomOutIcon
      fontSize="medium"
      onClick={() => zoomOut()}
      sx={{ cursor: "pointer", color: "#fff", marginRight: "0.5%" }}
    />
    <CenterFocusStrongIcon
      fontSize="medium"
      onClick={() => resetTransform()}
      sx={{ cursor: "pointer", color: "#fff", marginRight: "0.5%" }}
    />
  </Box>
);
type animationVideo = {
  animationId: number;
  animationTagName: string;
  bannerUrl: string;
  homepageOrder: number;
  videoUrl: string;
};

const HomePage: React.FC = () => {
  const {
    selectAnim,
    myVideosAnim,
    setSelectAnim,
    activeAnim,
    setActiveAnim,
    activeAnimIndex,
    setActiveAnimIndex,
    cartCount,
    incrementCartCount,
    decrementCartCount,
    isSystemNumber,
    setSystemNumber,
    isAnimationId,
    setAnimationId,
  } = useCart();
  const { defaultLanguage } = useLanguageContext();
  const transformComponentRef = useRef<ReactZoomPanPinchRef | null>(null);
  const [activeTab, setActiveTab] = useState(0);
  const [viewType, _setViewType] = useState<"display" | "grid">("display");
  const [changeCount, setChangeCount] = useState(cartCount);
  const [_selectedImage, setSelectedImage] = useState<string | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFullscreen, isSetFullscreen] = useState(false);
  const [isplaying, setIsPlaying] = useState(false);
  const [isManuallyPlayed, _setIsManuallyPlayed] = useState(false); // Tracks manual play state
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPDF, setIsPDF] = useState(false);
  //  After  Get System id
  const [isSystemData, setSystemData] = useState<SystemData[]>([]);
  const [isThumbnail, setThumbnail] = useState<posterData[]>([]);
  const [isSetAnimList, setAnimList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isShortUrl, setShortUrl] = useState(String);
  const [isSystemStatus, setSystemStatus] = useState(false);
  const [isLandingStatus, setLandingStatus] = useState(false);
  const [isListStatus, setListStatus] = useState(false);
  const [isPosterStatus, setPosterStatus] = useState(false);
  const [isFavoriteAnim, setFavoriteAnim] = useState(false);
  const [isFavList, setFavList] = useState<favoriteAnim[]>([]);
  const userViewType = Number(localStorage.getItem("viewType"));
  const [isLoading, setIsLoading] = useState(false);
  const [copyLoading, setCopyLoading] = useState(false);
  const [_isAnimationVideo, setIsAnimationVideo] =
    useState<animationVideo | null>(null);
  const [_iscurrentSystem, setCurrentSystem] = useState<number | null>(null);
  const [_iscurrentAnim, setCurrentAnim] = useState<number | null>(null);
  const [isRestrictionOpen, setIsRestrictionOpen] = useState(false);
  const savedAnimationId = localStorage.getItem("selectedAnimationId");
  const savedSystemId = localStorage.getItem("selectedSystemId");
  const isMobile = useMediaQuery("(max-width:820px)");
  const isPlayingLocal = localStorage.getItem("isPlaying")


  useEffect(() => {
    if (isPlayingLocal === "true") {
      setIsPlaying(true)
    }
  }, [isPlayingLocal])

  useEffect(() => {
    if (isSystemData.length > 0) {
      const tabIndex = localStorage.getItem("selectedSystemId");
      const data = isSystemData.findIndex((d) => d.systemNumber === Number(tabIndex));
      if(data === -1){
        setActiveTab(0)
        return
      }
      console.log("tab index from", data);
      setActiveTab(data);
    }
  }, [isSystemData, activeTab]);


  useEffect(() => {
    const getSystemDetail = async () => {
      try {
        const response = await axiosInstance.get(
          API_BASE_URL + "systems/user-systems"
        );
        if (response.status === 200) {
          if (savedSystemId) {
            setSystemNumber(Number(savedSystemId));
            setSystemData(response.data.data); // Save data to state
            setSystemStatus(true);
            setCurrentSystem(Number(savedSystemId));
          } else {
            setSystemNumber(response.data.data[0].systemNumber);
            setSystemData(response.data.data); // Save data to state
            setSystemStatus(true);
            setCurrentSystem(response.data.data[0].systemNumber);
          }
        }
      } catch (error) {
        const errCode = error as AxiosError<{ status: number }>;
        if (errCode.response && errCode.response.status === 401) {
          setIsRestrictionOpen(true);
        } else {
          toast.error("Something went wrong", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        }
        throw error;
      }
    };
    getSystemDetail();
  }, []);

  useEffect(() => {
    const savedAnimationId = localStorage.getItem("selectedAnimationId");
    const savedSystemId = localStorage.getItem("selectedSystemId");

    if (savedAnimationId && savedSystemId) {
      const basePayload = {
        systemId: JSON.stringify(savedSystemId),
      };
      const fetchData = async () => {
        try {
          const landingPayload = {
            systemId: JSON.stringify(savedSystemId),
          };

          const landingResponse = await axiosInstance.post(
            API_BASE_URL + "animation/landing",
            landingPayload
          );

          if (landingResponse.status >= 200 && landingResponse.status <= 300) {
            const landingData = landingResponse.data.data[0];
            setIsAnimationVideo(landingData);
            setAnimationId(landingData.animationId);
            setActiveAnim(landingData.animationId);
            setActiveAnimIndex(Number(savedAnimationId));
            setLandingStatus(true);
            setCurrentAnim(landingData.animationId);

            // Set PDF availability based on API response
            setIsPDF(landingData.isAvailableInPdf);
          } else {
          }

          // Fetch animation list (without animationId)
          const listResponse = await axiosInstance.post(
            API_BASE_URL + "animation/list",
            basePayload
          );

          if (listResponse.status >= 200 && listResponse.status <= 300) {
            setAnimList(listResponse.data.data);
            setListStatus(true);
          } else {
          }
        } catch (err) {
        }
      };

      fetchData();
    }

    else if (isSystemNumber && !savedAnimationId && !savedSystemId) {


      const fetchData = async () => {
        try {
          // Fetch landing animation
          const landingPayload = {
            systemId: JSON.stringify(isSystemNumber),
          };

          const landingResponse = await axiosInstance.post(
            API_BASE_URL + "animation/landing",
            landingPayload
          );
          console.log("landing", landingResponse);

          if (landingResponse.status >= 200 && landingResponse.status <= 300) {
            console.log("from landing else", landingResponse.data.data[0]?.animationId);
            localStorage.setItem("selectedAnimationId", landingResponse?.data?.data[0]?.animationId);
            localStorage.setItem("selectedSystemId", isSystemNumber.toString());
            const landingData = landingResponse.data.data[0];
            console.log("response data", landingData)
            setIsAnimationVideo(landingData);
            setAnimationId(landingData.animationId);
            setActiveAnim(landingData.animationId);
            setActiveAnimIndex(landingData.animationId);
            setLandingStatus(true);
            setCurrentAnim(landingData.animationId);

            // listResponseSet PDF availability based on API response
            setIsPDF(landingData.isAvailableInPdf);
          } else {
          }
          const basePayload = {
            systemId: JSON.stringify(isSystemNumber),
          };
          // Fetch animation list (without animationId)
          const listResponse = await axiosInstance.post(
            API_BASE_URL + "animation/list",
            basePayload
          );

          if (listResponse.status >= 200 && listResponse.status <= 300) {
            setAnimList(listResponse.data.data);
            setListStatus(true);
          } else {
          }
        } catch (error) {
          const errCode = error as AxiosError<{ status: number }>;
          if (errCode.response && errCode.response.status === 401) {
            setIsRestrictionOpen(true);
          } else {
            toast.error("Something went wrong", {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
            });
          }
          throw error;
        }
      };

      fetchData();
    } else {

    }
    // }
  }, [isSystemNumber]);

  //   Animation posters list
  useEffect(() => {
    const savedAnimationId = localStorage.getItem("selectedAnimationId");
    const savedSystemId = localStorage.getItem("selectedSystemId");

    if (savedAnimationId && savedSystemId) {
      const payload = {
        animationId: JSON.stringify(savedAnimationId),
      };
      const fetchData = async () => {
        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "animation/animation-posters",
            payload
          );
          if (response.status >= 200 && response.status <= 300) {
            setThumbnail(response.data.data);
            setPosterStatus(true);
          } else {
          }
        } catch (err) {
        }
      };
      fetchData();
    } else if (isAnimationId && !savedAnimationId && !savedSystemId) {

      const payload = {
        animationId: JSON.stringify(isAnimationId),
      };
      const fetchData = async () => {
        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "animation/animation-posters",
            payload
          );
          if (response.status >= 200 && response.status <= 300) {

            setThumbnail(response.data.data);
            setPosterStatus(true);
          } else {
          }
        } catch (error) {
          const errCode = error as AxiosError<{ status: number }>;
          if (errCode.response && errCode.response.status === 401) {
            setIsRestrictionOpen(true);
          } else {
            toast.error("Something went wrong", {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
            });
          }
          throw error;
        }
      };
      fetchData(); // Passing the payload as an argument
    } else {
    }
  }, [isAnimationId]); // Empty dependency array ensures it runs only once on page load



  // Simulate a 3-second loading period
  useEffect(() => {
    if (
      isSystemStatus &&
      isLandingStatus &&
      isListStatus &&
      isPosterStatus &&
      isSystemNumber
    ) {

      setLoading(true); // Start loading when modal opens
      const timer = setTimeout(() => {
        setLoading(false); // Just to simulate loading
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [
    isSystemStatus,
    isLandingStatus,
    isListStatus,
    isPosterStatus,
    isSystemNumber,
  ]);


  const handleTabChange = (newValue: number) => {
    // localStorage.setItem("selectedSystemNumber", isSystemData ? isSystemData[newValue].systemNumber.toString() : "0");
    // localStorage.setItem("activeTab", newValue.toString());
    // localStorage.setItem("selectedAnimationId", );
    setActiveTab(newValue);
    setIsPlaying(false)
    // The below codes are using once tab change get systemNumber and set the systemNumber
    // Get the selected category based on the newValue (tab index)
    const selectedCategory = isSystemData ? isSystemData[newValue] : null;


    // Extract the systemNumber and index (newValue)
    const systemNumber = selectedCategory?.systemNumber ?? null;
    localStorage.setItem("selectedSystemId", systemNumber ? systemNumber?.toString() : "");
    localStorage.setItem("isPlaying", "false");


    // const index = newValue; // The index of the selected tab

    // Perform your logic using both values
    if (systemNumber !== null) {

      // Call setSystemNumber or any other function that requires systemNumber
      setSystemNumber(systemNumber); // This could update your state with the system number

      const fetchData = async () => {
        try {
          // Fetch landing animation
          const landingPayload = {
            systemId: JSON.stringify(systemNumber),
          };

          const landingResponse = await axiosInstance.post(
            API_BASE_URL + "animation/landing",
            landingPayload
          );
          console.log("landing", landingResponse);

          if (landingResponse.status >= 200 && landingResponse.status <= 300) {
            localStorage.setItem("selectedAnimationId", landingResponse?.data?.data[0]?.animationId);
            const landingData = landingResponse.data.data[0];
            console.log("response data", landingData)
            setIsAnimationVideo(landingData);
            setAnimationId(landingData.animationId);
            setActiveAnim(landingData.animationId);
            setActiveAnimIndex(landingData.animationId);
            setLandingStatus(true);
            setCurrentAnim(landingData.animationId);

            // listResponseSet PDF availability based on API response
            setIsPDF(landingData.isAvailableInPdf);
          } else {
          }
        } catch (e) {
          console.log("error")
        }
      }
      fetchData()
    }


  };


  const handleClickLink = (id: number) => {
    setSelectAnim((prevIds: number[]) => [...prevIds, id]);
    setChangeCount(cartCount + 1);
    incrementCartCount(changeCount);
  };

  const handleRemoveAnim = (rid: number) => {
    const updatedSelectAnim = selectAnim.filter((item) => item !== rid);
    setSelectAnim(updatedSelectAnim);
    setChangeCount(cartCount - 1);
    decrementCartCount(changeCount);
  };

  const preloadImage = (src: string, callback: () => void) => {
    const img = new Image();
    img.src = src;
    img.onload = callback;
  };

  const handlePrevious = () => {
    const newIndex =
      currentIndex === 0 ? (isThumbnail?.length || 0) - 1 : currentIndex - 1;
    const nextImage = isThumbnail?.[newIndex]?.imageUrl || "";

    preloadImage(nextImage, () => {
      setCurrentIndex(newIndex);
    });
    setTimeout(() => {
      transformComponentRef.current?.resetTransform(); // Resets zoom and position
    }, 50);
  };

  const handleNext = () => {
    const newIndex =
      currentIndex === (isThumbnail?.length || 0) - 1 ? 0 : currentIndex + 1;
    const nextImage = isThumbnail?.[newIndex]?.imageUrl || "";

    preloadImage(nextImage, () => {
      setCurrentIndex(newIndex);
    });
    setTimeout(() => {
      transformComponentRef.current?.resetTransform(); // Resets zoom and position
    }, 50);
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") {
        handlePrevious();
      } else if (e.key === "ArrowRight") {
        handleNext(); // You'll need to define this similar to handlePrevious
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handlePrevious, handleNext]);

  const handleViewImage = (src: string, index: number) => {
    // Update the current index and set the selected image
    setCurrentIndex(index);
    setSelectedImage(src);

    // Toggle fullscreen mode
    isSetFullscreen(!isFullscreen);

    // Pause any ongoing playback
    setIsPlaying(false);

    // Attempt to enter fullscreen mode if not already in fullscreen
    const element = document.getElementById("imageFullscreen");
    if (!isFullscreen) {
      if (element?.requestFullscreen) {
        element.requestFullscreen().catch((err) => {
          console.error(
            `Error attempting to enable full-screen mode: ${err.message} (${err.name})`
          );
        });
      }
    }
  };

  useEffect(() => {
    if (!isFullscreen && transformComponentRef.current) {
      setTimeout(() => {
        transformComponentRef.current?.resetTransform(); // Resets zoom and position
      }, 50); // Small delay to ensure the component is updated
    }
  }, [isFullscreen]);

  // Handle fullscreen change event
  useEffect(() => {
    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        isSetFullscreen(false);
        setSelectedImage(null);
        // setIsManuallyPlayed(true);
        if (isManuallyPlayed) {
          setIsPlaying(false);
          // setIsManuallyPlayed(true);
        } else {
          setIsPlaying(false);
        }
      }
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [isManuallyPlayed]);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => setIsModalOpen(false);

  //Dialog function --ends
  const handleCopyAnimUrl = () => {
    setCopyLoading(true);
    const payload = {
      trackType: "share_copy_generate_link",
      languageId: defaultLanguage,
      websiteId: 1,
      animationId: JSON.stringify(isAnimationId),
    };

    const generateShortURL = async (payload: any) => {
      try {
        const response = await axiosInstance.post(
          API_BASE_URL + "share/copy-shortUrl",
          payload
        );
        if (response.status >= 200 && response.status <= 300) {
          const shortCode = response.data.data.links[0].shortUrl;
          // Split the URL by '/'
          const urlSegments = shortCode.split("/");
          // Get the last segment
          const getCode = urlSegments[urlSegments.length - 1];

          const shortUrl = `${BASE_SHORT_URL}/${getCode}`;
          setShortUrl(shortUrl);
          navigator.clipboard.writeText(shortUrl).then(() => { });
          // Copy the short URL to the clipboard

          setTimeout(() => {
            setCopyLoading(false);
            toast.success("Animation Copied successfully !!!", {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 2000);
        }
      } catch (error) {
        const errCode = error as AxiosError<{ status: number }>;
        if (errCode.response && errCode.response.status === 401) {
          setIsRestrictionOpen(true);
        } else {
          toast.error("Something went wrong", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        }
        throw error;
      }
    };
    generateShortURL(payload);

    navigator.clipboard.writeText(isShortUrl).then(() => { });
  };

  const handleFavoriteToggle = async (animId: number) => {
    setIsLoading(true);

    const isFavorite = isFavList.some((item) => item.animationId === animId);

    const url = isFavorite
      ? API_BASE_URL + "animation-favorites/remove-favorite"
      : API_BASE_URL + "animation-favorites/add-favorite";

    const payload = isFavorite
      ? { animationId: animId }
      : { webSiteId: 1, animationId: animId };

    try {
      const response = isFavorite
        ? await axiosInstance.delete(url, { data: payload })
        : await axiosInstance.post(url, payload);

      if (response.status >= 200 && response.status < 300) {
        setTimeout(() => {
          setIsLoading(false);
          FavListData();
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 2000);
      }
    } catch (error) {
      const errCode = error as AxiosError<{ status: number }>;
      if (errCode.response && errCode.response.status === 401) {
        setIsRestrictionOpen(true);
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
      }
      throw error;
    }
  };

  const FavListData = async () => {
    try {
      const response = await axiosInstance.get(
        API_BASE_URL + "animation-favorites/list-favorites"
      );

      if (response.status >= 200 && response.status < 300) {
        const favorites = response.data.data?.data || []; // Ensure it's an array
        setFavList(favorites);

        // Check if the active animation exists in the favorite list
        setFavoriteAnim(
          Array.isArray(favorites) &&
          favorites.some((item: any) => item.animationId === isAnimationId)
        );
      } else {
        setFavoriteAnim(false);
      }
    } catch (error: any) {
      console.error("Error fetching favorites:", error);

      // If the error is a 404 (Not Found), set favorites to an empty array
      if (error.response?.status === 404) {
        setFavList([]);
        setFavoriteAnim(false);
      }
    }
  };

  return (
    <Box
      sx={{
        paddingTop: "10px",
        paddingBottom: "10px",
        paddingRight: { xs: "15px", sx: "15px", lg: "1px" },
      }}
    >
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            transform: "scale(1.4)",
            zIndex: 9999,
            backgroundImage: `url(${VISUALIZE__URL}link.webm)`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "50px 50px", // Set image size to 50px width and height
            backgroundColor: "#fff",
            opacity: 0.5,
          }}
        >
          {/* <CircularProgress /> */}
        </Box>
      ) : (
        // </Box>
        <>
          <Box sx={{ margin: "0 auto", paddingX: "15px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingRight: { xs: "0px", sm: "10px", md: "30px", lg: "1px" }, // Add space on the right for mobile and larger screens
              }}
            >
              <Grid container className="one">
                <Grid
                  item
                  sm={12}
                  md={12} // Reduce size for medium screens by adjusting this value
                  lg={6}
                  sx={{
                    display: "flex",
                    padding: {
                      xs: "0 4px",
                      sm: "0 2px",
                      md: "0 10px",
                    }, // Adjust padding for mobile and small screens
                    alignItems: "center",
                    justifyContent: { xs: "center", sm: "flex-start" }, // Center items on mobile, left align on larger screens
                    flexDirection: { xs: "column", sm: "row" }, // Stack content vertically on mobile, horizontal on larger screens
                    width: "100%", // Ensure it takes full width of its container
                  }}
                >
                  {/* //New Nav Menu start*/}
                  <HomeNav
                    isSystemData={isSystemData}
                    handleTabChange={handleTabChange}
                    isActiveTab={activeTab}
                  />
                  {/* //New Nav Menu end*/}
                </Grid>
                {/* For PDF & Copy Section */}
                <Grid
                  item
                  sm={12}
                  md={12}
                  lg={6}
                  sx={{
                    display: "flex",
                    // padding: { xs: "0 2px", sm: "0 2px" }, // Adjust padding for mobile and small screens
                    padding: { xs: "0 10px", sm: "0 10px" }, // Adjust padding for mobile and small screens
                    // alignItems: "center",
                    justifyContent: { xs: "center", sm: "flex-end" }, // Center items on mobile, left align on larger screens
                    flexDirection: { xs: "column", sm: "row" }, // Stack content vertically on mobile, horizontal on larger screens
                    width: "100%", // Ensure it takes full width of its container
                    // mt: { xs: 1, sm: 2, md: 1 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    {isThumbnail &&
                      isThumbnail.map((thumb, index) => (
                        <Box
                          key={index}
                          sx={{ position: "relative", width: 90 }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              // height: { xs: 50, sm: 70, md: 90, lg: 90 },
                              height: { xs: 20, sm: 30, md: 40, lg: 50 }, // Reduced height for landscape
                              borderRadius: 2,
                              overflow: "hidden",
                              display: "flex",
                              justifyContent: "center",
                              cursor: "pointer",
                              transition: "transform 0.2s ease-in-out",
                              boxShadow: "3px 3px 9px 0px rgb(79 77 77 / 65%)",
                              "&:hover": {
                                transform: "scale(1.05)",
                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                              },
                            }}
                          >
                            <img
                              src={thumb.imageUrl}
                              alt={thumb.imageUrl}
                              id="image-full"
                              style={{
                                width: "100%",
                                height: "100%",
                                // borderRadius: 10,
                                objectFit: "cover",
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              opacity: 0,
                              transition: "opacity 0.3s ease-in-out",
                              backgroundColor: "rgba(0, 0, 0, 0.5)",
                              borderRadius: 2,
                              "&:hover": {
                                opacity: 1,
                              },
                            }}
                          >
                            <Tooltip title="View Image">
                              <IconButton
                                onClick={() =>
                                  handleViewImage(thumb.imageUrl, index)
                                }
                                sx={{
                                  color: "#fff",
                                  width: "25px",
                                  height: "25px",
                                  backgroundColor: "rgba(255, 255, 255, 0.3)",
                                  "&:hover": {
                                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                                  },
                                }}
                              >
                                <VisibilityIcon sx={{ fontSize: "15px" }} />
                              </IconButton>
                            </Tooltip>
                          </Box>

                          {/* </>
                      )} */}
                        </Box>
                      ))}

                    {/* PDF view */}
                    {isPDF ? (
                      <Tooltip title="PDF">
                        <IconButton
                          onClick={handleOpenModal}
                          sx={{
                            bgcolor: "#1976d2",
                            "&:hover": { bgcolor: "#be1e2d" },
                            "&:hover .dashicon": { color: "#fff" },
                            width: { xs: 30, sm: 50 }, // Smaller width on mobile (xs), larger on sm+
                            height: { xs: 30, sm: 50 }, // Smaller height on mobile (xs), larger on sm+
                            "& .dashicon": {
                              fontSize: { xs: "20px", sm: "24px" }, // Smaller icon size on mobile
                            },
                          }}
                        >
                          <PictureAsPdfIcon
                            className="dashicon"
                            sx={{
                              color: "#fff",
                              fontSize: isMobile ? "18px" : "24px",
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    ) : null}

                    {isModalOpen && (
                      <Box sx={{ marginTop: 2 }}>
                        <PdfViewerModal
                          animationId={
                            savedAnimationId
                              ? Number(savedAnimationId)
                              : isAnimationId
                          }
                          onClose={handleCloseModal}
                        />
                      </Box>
                    )}

                    {/* For Copy Object */}
                    <Tooltip title="Copy">
                      <IconButton
                        sx={{
                          bgcolor: "#1976d2",
                          "&:hover": { bgcolor: "#be1e2d" },
                          "&:hover .dashicon": { color: "#fff" },
                          width: { xs: 30, sm: 50 }, // Smaller width on mobile (xs), larger on sm+
                          height: { xs: 30, sm: 50 }, // Smaller height on mobile (xs), larger on sm+
                          "& .dashicon": {
                            fontSize: { xs: "20px", sm: "24px" }, // Smaller icon size on mobile
                          },
                        }}
                        onClick={handleCopyAnimUrl}
                      >
                        {copyLoading ? (
                          <CircularProgress
                            sx={{
                              color: "#fff",
                            }}
                            size={20} // Reduce the size
                          />
                        ) : (
                          <ContentCopyIcon
                            className="dashicon"
                            sx={{
                              color: "#fff",
                              fontSize: isMobile ? "18px" : "24px",
                            }}
                          />
                        )}
                      </IconButton>
                    </Tooltip>
                    {userViewType === 1 && (
                      <>
                        <Tooltip title="Share">
                          <IconButton
                            sx={{
                              bgcolor: "#1976d2",
                              "&:hover": { bgcolor: "#be1e2d" },
                              "&:hover .dashicon": { color: "#fff" },
                              width: isMobile ? 30 : 50,
                              height: isMobile ? 30 : 50,
                            }}
                            onClick={() => {
                              if (selectAnim.includes(activeAnim)) {
                                handleRemoveAnim(activeAnim);
                              } else {
                                if (selectAnim.length + myVideosAnim.length >= 8) {
                                  toast.warning(
                                    "You can only share up to 8 animations at a time."
                                  );
                                  return;
                                }
                                handleClickLink(activeAnim);
                                toast.success(
                                  "Animation added to your collection."
                                );
                              }
                            }}
                          >
                            {selectAnim.includes(activeAnim) ? (
                              <CloseIcon
                                className="dashicon"
                                sx={{
                                  color: "#fff",
                                  fontSize: isMobile ? "18px" : "24px",
                                }}
                              />
                            ) : (
                              <ShareIcon
                                className="dashicon"
                                sx={{
                                  color: "#fff",
                                  fontSize: isMobile ? "18px" : "24px",
                                }}
                              />
                            )}
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Favorites">
                          <IconButton
                            sx={{
                              backgroundColor: isFavoriteAnim
                                ? "#ffd2d2"
                                : "#1976d2",
                              "&:hover": { bgcolor: "#be1e2d" },
                              "&:hover .dashicon": { color: "#fff" },
                              width: isMobile ? 30 : 50,
                              height: isMobile ? 30 : 50,
                            }}
                            onClick={() => handleFavoriteToggle(activeAnim)}
                          >
                            {isLoading ? (
                              <CircularProgress
                                sx={{
                                  color: isFavoriteAnim ? "#f20808" : "#fff",
                                }}
                                size={20} // Reduce the size
                              />
                            ) : (
                              <FavoriteIcon
                                className="dashicon"
                                sx={{
                                  color: isFavoriteAnim ? "#f20808" : "#fff",
                                  fontSize: isMobile ? "18px" : "24px",
                                }}
                              />
                            )}
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                padding: { xs: "10px", sm: "20px", md: "10px", lg: "10px" },
                borderRadius: "8px",
                paddingRight: { xs: "5px", sm: "1px" },
              }}
            >
              <Box>
                <HomepageAnimation
                  animationList={isSetAnimList}
                  viewType={viewType}
                  playing={isplaying}
                  actIndex={activeAnimIndex}
                />
                {/* )} */}
              </Box>
            </Box>
          </Box>
        </>
      )}
      <div
        id="imageFullscreen"
        style={{ display: isFullscreen ? "block" : "none" }}
      >
        <Box className="img_view_section" sx={{}}>
          <TransformWrapper initialScale={1} ref={transformComponentRef}>
            {(utils) => (
              <React.Fragment>
                <Controls
                  zoomIn={utils.zoomIn}
                  zoomOut={utils.zoomOut}
                  resetTransform={utils.resetTransform}
                />
                {isFullscreen && (
                  <>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "10px",
                        zIndex: 10,
                        transform: "translateY(-50%)",
                      }}
                    >
                      <Button
                        onClick={handlePrevious}
                        sx={{
                          background: "rgba(0,0,0,0.5)",
                          color: "#fff",
                          padding: "10px",
                          minWidth: 0,
                          borderRadius: "50%",
                          "&:hover": {
                            background: "rgba(0,0,0,0.7)",
                          },
                        }}
                      >
                        <ChevronLeftIcon />
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        zIndex: 10,
                        transform: "translateY(-50%)",
                      }}
                    >
                      <Button
                        onClick={handleNext}
                        sx={{
                          background: "rgba(0,0,0,0.5)",
                          color: "#fff",
                          padding: "10px",
                          minWidth: 0,
                          borderRadius: "50%",
                          "&:hover": {
                            background: "rgba(0,0,0,0.7)",
                          },
                        }}
                      >
                        <ChevronRightIcon />
                      </Button>
                    </Box>
                  </>
                )}

                <TransformComponent
                  wrapperStyle={{
                    width: "100vw",
                    height: "100vh",
                    overflow: "auto",
                  }}
                >
                  <img
                    src={isThumbnail?.[currentIndex]?.imageUrl || ""}
                    id="image-fullscreen"
                    style={{
                      width: "100vw",
                      height: "100vh",
                      objectFit: "contain",
                      aspectRatio: window.innerWidth > 768 ? "16/9" : "9/16",
                    }}
                  />
                </TransformComponent>
              </React.Fragment>
            )}
          </TransformWrapper>
        </Box>
      </div>
      <LoginRestriction open={isRestrictionOpen} />
    </Box>
  );
};
export default HomePage;
